import { TFunction } from "i18next";
import { z } from "zod";

export const getFlowTestFormSchema = (t: TFunction) => {
  return z.object({
    testTypeId: z.number().positive().nullable().optional(),
    startDate: z.preprocess(
      (val) => (typeof val === "string" ? new Date(val) : val instanceof Date ? val : undefined),
      z.date().optional()
    ) as z.ZodType<Date | undefined>,
    aquiferId: z.number().positive().nullable().optional(),
  });
};

export type FlowTestForm = z.infer<ReturnType<typeof getFlowTestFormSchema>>;